import React, {Component} from "react";

class MetricFilter extends Component {
    state = {
        metric: 'volume',
    };
    componentDidMount(){

    }
    resetMetricFilter(){
        this.setState({
            metric: 'volume',
        })
    }
    changeMetric(metric, e) {
        this.setState({
            metric:metric,
        });
        this.props.onSelectMetric(metric);
    }
    render() {
        var vcls = "btn btn-sm btn-default switchMetric";
        var ccls = "btn btn-sm btn-default switchMetric";
        if(this.state.metric=='volume' ) {
            vcls = "btn btn-sm btn-primary switchMetric";
            ccls = "btn btn-sm btn-default switchMetric";
        }
        if(this.state.metric=='count' ) {
            vcls = "btn btn-sm btn-default switchMetric";
            ccls = "btn btn-sm btn-primary switchMetric";
        }
        return (
            <div className="alignedCenter">
                <div className="btn-group">
                    <button className={vcls} type="button" value="volume" onClick={this.changeMetric.bind(this,'volume')}>volume </button>
                    <button className={ccls} type="button" value="count" onClick={this.changeMetric.bind(this,'count')}>count </button>
                </div>
            </div>
        );
    }
}
export default MetricFilter;